import React from 'react';

// get object (arrayProp) from parent component
// destructure two dynamic properties (option value and option name) for each option
const Select = ({arrayProp, optionValue, optionName, labelFor, label, selectName, changeHandler}) => {

  return (
    <>
      <label htmlFor={labelFor} className="instructions">{label}</label>

      <select 
        name={selectName}
        id={labelFor}
        onChange={changeHandler}
        required={true}
        aria-required="true"
        aria-label={`select one of the ${label}`}
      >
        <option value="">--Please choose an option--</option>
          {
            arrayProp.map((element, index) => {
              return (
                <option key={`${index}`} value={`${element[optionValue]}`}>{element[optionName]}</option>
              )
            })
          }
      </select> 

    </>
  )
}
export default Select;